import {
  PointsOfContact,
  PointsOfContactArgs,
  getPointsOfContact,
} from '../assets/ts/data/points-of-contact'
import useServerData from './use-server-data'

function usePointsOfContacts(fetchArgs, waitOnParentDependency = false) {
  const {
    data: pointsOfContact,
    error: pointsOfContactError,
    fetchData: fetchPointsOfContact,
    isLoading: pointsOfContactIsLoading,
  } = useServerData<PointsOfContact, PointsOfContactArgs>(
    getPointsOfContact,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchPointsOfContact,
    pointsOfContact,
    pointsOfContactError,
    pointsOfContactIsLoading,
  }
}

export default usePointsOfContacts
